"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _ApiClient = _interopRequireDefault(require("../ApiClient"));

var _Dataset = _interopRequireDefault(require("./Dataset"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * The Figure model module.
 * @module model/Figure
 * @version 0.2.0
 */
var Figure = /*#__PURE__*/function () {
  /**
   * Constructs a new <code>Figure</code>.
   * @alias module:model/Figure
   */
  function Figure() {
    _classCallCheck(this, Figure);

    Figure.initialize(this);
  }
  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */


  _createClass(Figure, null, [{
    key: "initialize",
    value: function initialize(obj) {}
    /**
     * Constructs a <code>Figure</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/Figure} obj Optional instance to populate.
     * @return {module:model/Figure} The populated <code>Figure</code> instance.
     */

  }, {
    key: "constructFromObject",
    value: function constructFromObject(data, obj) {
      if (data) {
        obj = obj || new Figure();

        if (data.hasOwnProperty('datasets')) {
          obj['datasets'] = _ApiClient["default"].convertToType(data['datasets'], [_Dataset["default"]]);
        }

        if (data.hasOwnProperty('options')) {
          obj['options'] = _ApiClient["default"].convertToType(data['options'], {
            'String': Object
          });
        }
      }

      return obj;
    }
  }]);

  return Figure;
}();
/**
 * @member {Array.<module:model/Dataset>} datasets
 */


Figure.prototype['datasets'] = undefined;
/**
 * @member {Object.<String, Object>} options
 */

Figure.prototype['options'] = undefined;
var _default = Figure;
exports["default"] = _default;